module.exports = __webpack_public_path__ + "static/img/datatronica.4a1562e.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/images/clientes/datatronica.png
// module id = rK1C
// module chunks = 1